<template>

  <div>

    <!-- marco principal de la aplicación cabecera datos conexion y usuario -->
    <!-- Footer -->
    <shp-header-app v-if="$route.name !== 'ShpLogin' && $route.name !== 'ShpInitStyle' "></shp-header-app>
    <v-content class="mb-2">
      <router-view></router-view>
    </v-content>
    <!-- Footer -->
    <shp-footer-app v-if="$route.name !== 'ShpLogin' && $route.name !== 'ShpInitStyle' "></shp-footer-app>
  </div>
</template>
<script>

import ShpHeaderApp from '@/components/ShpHeaderApp'
import ShpFooterApp from '@/components/ShpFooterApp'

export default {
  name: 'ShpApp',
  components: {
    ShpHeaderApp,
    ShpFooterApp
  },
  mounted () {
    let urlCabecera = localStorage.getItem('urlCabecera')
    let styleOrgPath = ''
    styleOrgPath = (urlCabecera !== undefined) ? urlCabecera : 'base'
    import('../../static/style/' + styleOrgPath + '/main.sass').catch(error => {
      console.log(error)
      import('../../static/style/base/main.sass')
    })

    const favicon = document.getElementById('favicon')
    favicon.href = '/static/style/' + styleOrgPath + '/img/favicon.ico'

    /*
     * Evento carga pagina principal
     */
    this.$bus.$on('evento-cargaPaginaApp', () => {
      // carga la lista de empresas
      this.$router.push('/' + this.$store.getters.getModulo.toLowerCase())
    })
  },
  beforeDestroy () {
    /*
     * evento descarga pagina principal
     */
    this.$bus.$off('evento-cargaPaginaApp')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShpApp.vue